<div
    class="flex flex-col justify-between items-center border-2 border-blurple rounded-xl absolute bg-white p-1 z-20"
    [ngStyle]="{
        'height.px': tileHeight,
        'width.px': width,
    }">
    <p-button
        (click)="onClickBookSession($event)"
        severity="primary"
        label="Book"
        styleClass="w-full"
        class="w-full" />
    <p-button
        (click)="onClickClearSelectedSession($event)"
        label="Clear"
        [outlined]="true"
        severity="primary"
        styleClass="w-full"
        class="w-full" />
</div>
